angular.module("avant.interceptors").factory "AuthenticationFailureInterceptor", [
  "$rootScope", "$q", '$injector', '$window',
  ($rootScope, $q, $injector, $window) ->

    responseError: (rejection) ->
      # Prevent redirect on demo pages
      if $window.location.pathname.indexOf("/demo") == 0
        return $q.reject(rejection)

      handleSessionTimeout = (rejection) ->
        if rejection.config.url?.match(/^\/api\/v\d+\/.*$/)
          return $injector.get('AuthenticationService')
            .refresh_token()
            .then((data) ->
              rejection.config.headers['X-CSRF-TOKEN'] = data.csrf_token
              $injector.get('$http')(rejection.config)
            )
        if rejection.data.timeout_action
          $injector.get('AuthenticationService')
                   .timeoutSession(rejection.data)
        $q.reject(rejection)

      handleLegacyUnauthenticatedRequest = (rejection) ->
        # When session timeout is not enabled for the locale or partner, fall
        # back to the old behavior
        $injector.get('AuthenticationService')
          .reauthenticate()
          .then (data) ->
            rejection.config.headers['X-CSRF-TOKEN'] = data.csrf_token
            $injector.get('$http')(rejection.config)

      switch rejection.status
        when 401, 404
          if rejection.status is 404 and !rejection.data?.resource? #legacy
            return $q.reject(rejection)
          if rejection.config.url == '/login'
            return $q.reject(rejection)
          if $window.avantConfig.content?.session_timeout_enabled
            handleSessionTimeout(rejection)
          else
            handleLegacyUnauthenticatedRequest(rejection)
        else
          $q.reject(rejection)
]

